module.exports = __webpack_public_path__ + "img/pr-4.d08a7145.png";